import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Imagecard from '../Imagecard';
import Posisiwindows from '../../hook/Posisiwindows';

const index = () => {
    const styleku = makeStyles((theme)=>({
        root :{
            minHeight:'100vh',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            [theme.breakpoints.down("md")]:{
                flexDirection : 'column',
            },
            background:'white'
        }
    }));
    const classes = styleku();
    const checked = Posisiwindows('header');
    return (
        <div className={classes.root} id="menu-pilihan">
            <Imagecard  checked={checked}/>
        </div>
    )
}

export default index
